// Regular expressions
export const SLOT_ID_REGEX = /^slot-(\d+)-(\d+)(?:-(\d+))?$/;
export const CARD_ID_REGEX = /^card-(\d+)-(\d+)$/;

// Auto-scroll constants
export const EDGE_ZONE_PX = 100;
export const MAX_SCROLL_SPEED_PX = 12;

// MAX-WIDTH TIMELINE DAILY COLUMNS (px)
export const MAX_WIDTH_TIMELINE_DAILY_COLUMNS_PX = 148;